import { UI, HStack, VStack } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import React from 'react';
import { Pressable } from 'react-native';

import { OperationType } from '../../../../../../components/OperationType';

interface SubscriptionMainInfoProps {
  title: string;
  description: string;
  hasLeftovers?: boolean;
  onDetailsPress: () => void;
  isMobile?: boolean;
  unforcedFlex?: boolean;
}

export const SubscriptionMainInfo: React.FC<SubscriptionMainInfoProps> = ({
  title,
  description,
  hasLeftovers,
  onDetailsPress,
  isMobile,
  unforcedFlex,
}) => {
  if (isMobile) {
    return (
      <HStack
        space="inline.xxxs"
        alignItems="center"
        flex={unforcedFlex ? undefined : 1}
        justifyContent="space-between">
        <VStack space="stack.quarck">
          <UI.Text color="neutral.darkest" variant="semibold">
            {title}
          </UI.Text>
          <UI.Text variant="semibold" color="neutral.medium" fontSize={Typography['fontsize.xs']}>
            {description}
          </UI.Text>
        </VStack>
        <HStack space="inline.xxxs" alignItems="center">
          {hasLeftovers && <OperationType title="SOBRAS" />}
          <UI.Tooltip testID="details-tooltip" label="Ver detalhes">
            <Pressable onPress={onDetailsPress}>
              <UI.Icon name="Info" size="xs" />
            </Pressable>
          </UI.Tooltip>
        </HStack>
      </HStack>
    );
  }

  return (
    <HStack space="inline.xxxs" alignItems="center" flex={unforcedFlex ? undefined : 1}>
      <UI.Tooltip testID="details-tooltip" label="Ver detalhes">
        <Pressable onPress={onDetailsPress}>
          <UI.Icon name="Info" size="xs" />
        </Pressable>
      </UI.Tooltip>
      <VStack space="stack.quarck">
        <UI.Text color="neutral.darkest" variant="semibold">
          {title}
        </UI.Text>
        <UI.Text variant="semibold" color="neutral.medium" fontSize={Typography['fontsize.xs']}>
          {description}
        </UI.Text>
      </VStack>
      {hasLeftovers && <OperationType title="SOBRAS" />}
    </HStack>
  );
};
